var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 424c-97.06 0-176-79-176-176S158.94 80 256 80s176 79 176 176-78.94 176-176 176z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 432c-97.06 0-176-79-176-176S158.94 80 256 80s176 79 176 176-78.94 176-176 176z","className":"fa-primary","key":2})]);
}

Circle.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Circle;

Circle.default = Circle;
